import { StorageAdapter } from '../storage/StorageAdapter'

/**
 * IdMappingRepository — mapeo client_uuid <-> server_id sobre SQLite (CAP-04).
 *
 * Vive sobre la tabla `id_mapping(entity, client_uuid, server_id)` con PK(entity, client_uuid) e
 * indice idx_idmap_server(entity, server_id) (schema.js:107-111). NO importa el plugin: solo emite
 * SQL a traves del StorageAdapter (STOR-05).
 *
 * El cliente genera client_uuid (uuid v4) para sus entidades offline; el servidor
 * responde con el id auto-incremental real tras sincronizar. Este mapa permite
 * reescribir referencias locales y evitar reenvios duplicados.
 *
 * FRONTERA F2/F3: `setMapping` la LLAMA F3 al recibir el server_id en el push exitoso;
 * F2 solo provee la API/almacen (el repo aterriza aqui, las llamadas son F3).
 *
 * Lectura defensiva: el backend SQLite nativo (@capacitor-community/sqlite) `query` devuelve `{ values: [...] }` (filas-objeto);
 * el parseo del shape se mantiene DENTRO del repo (es el codigo real).
 */
class IdMappingRepositoryClass {
  /**
   * Registra (o actualiza) el server_id devuelto por el backend para un client_uuid.
   * Upsert idempotente: reintentar el mismo push no duplica filas.
   * @param {string} entity     'occurrence' | 'task' | ...
   * @param {string} clientUuid uuid v4 estable del cliente.
   * @param {number} serverId   id auto-incremental real del servidor.
   */
  async setMapping (entity, clientUuid, serverId) {
    await StorageAdapter.run(
      'INSERT INTO id_mapping (entity, client_uuid, server_id) VALUES (?,?,?) ' +
      'ON CONFLICT(entity, client_uuid) DO UPDATE SET server_id = excluded.server_id',
      [entity, clientUuid, serverId],
      true
    )
  }

  /** server_id para un client_uuid (null si aun no sincronizado). */
  async serverIdFor (entity, clientUuid) {
    const result = await StorageAdapter.query(
      'SELECT server_id FROM id_mapping WHERE entity=? AND client_uuid=?',
      [entity, clientUuid]
    )
    const row = result && result.values && result.values[0]
    return row ? row.server_id : null
  }

  /** client_uuid para un server_id (null si no existe localmente). Usa idx_idmap_server. */
  async clientUuidFor (entity, serverId) {
    const result = await StorageAdapter.query(
      'SELECT client_uuid FROM id_mapping WHERE entity=? AND server_id=?',
      [entity, serverId]
    )
    const row = result && result.values && result.values[0]
    return row ? row.client_uuid : null
  }
}

export const IdMappingRepository = new IdMappingRepositoryClass()
